module.exports = __webpack_public_path__ + "img/autoturisme.e8c02d1e.svg";